import { render, staticRenderFns } from "./carDamageList.vue?vue&type=template&id=bb370fca&scoped=true"
import script from "./carDamageList.vue?vue&type=script&lang=js"
export * from "./carDamageList.vue?vue&type=script&lang=js"
import style0 from "./carDamageList.vue?vue&type=style&index=0&id=bb370fca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb370fca",
  null
  
)

export default component.exports